module.exports = __webpack_public_path__ + "images/review_stars_half_cbc40758f17c5b1ccfde1224ffe748a8.png";